import React, { useState, useEffect, useContext } from "react";
import InputLogin from "../inputs/InputLogin";
import SearchableSelect from "../select/SearchableSelect";
import Switch from "../switch/Switch";
import ButtonTransparent from "../button/ButtonTransparent";
import StatusVerification from "../../components/layouts/StatusVerification";
import UploadPDF from "../inputs/UploadPDF"
import { UtilContext } from "../../context/UtilContext";
import { GLOBAL_LANGUAGE } from "../../language/language";

import { ReactComponent as COPY } from "../../assets/IconsColurs/IconsGeneral/copy.svg";
import CryptoJS from "crypto-js";

const BeneficiaryForm = ({
  index,
  data,
  error = false,
  ListCountry,
  onChange,
  copyToClipboard,
  ErrorCompany,
}) => {
  const { language } = useContext(UtilContext);
  const [isNaturalPerson, setIsNaturalPerson] = useState(
    data.type_person === 1
  );
  const [IDFinal, setIDFinal] = useState("");

  // Estados para los documentos
  const [document1, setdocument1] = useState(data?.documents_step_4?.doc_government_issued_id || "");
  const [document2, setdocument2] = useState(data?.documents_step_4?.doc_shareholder_certificate || "");

  const secretKey = process.env.REACT_APP_HASH;

  useEffect(() => {
    if (data.type_person !== undefined) {
      setIsNaturalPerson(data.type_person === 1);
    }
  }, [data.type_person]);

  useEffect(() => {
    if (data.id) {
      const encryptedId = CryptoJS.AES.encrypt(data.id.toString(), secretKey).toString();
      const urlSafeEncryptedId = encryptedId
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");

      setIDFinal(urlSafeEncryptedId);
    }
  }, [data]);

  // Manejar cambios en los documentos
  const handleDocumentChange = (field, file) => {
    onChange(field, file); // Actualiza el valor en el estado padre
    if (field === "doc_shareholder_certificate") {
      setdocument2(file);
    } else if (field === "doc_government_issued_id") {
      setdocument1(file);
    }
  };
  console.log("data", data);
  console.log("!data.documents_step_4", !!data.doc_shareholder_certificate);

  return (
    <div
      className={`bg-[#2B2B33] p-6 rounded-2xl w-full mt-4 mx-auto transition-colors duration-300 border ${ErrorCompany ? "border-[#FF928B]" : "border-transparent"
        }`}
    >
      <h2 className="text-lg font-semibold text-[#B7B7B9] mb-4">
        {GLOBAL_LANGUAGE[language].benefactor.title + " " + (index + 1)}
      </h2>

      {/* Tipo de persona */}
      <div className="flex items-center mb-6">
        <label className="mr-4 flex items-center text-[#B7B7B9]">
          <input
            type="radio"
            readOnly={data.id ? true : false}
            name={`personType-${index}`}
            checked={isNaturalPerson}
            value={isNaturalPerson}
            onChange={data.id ? null : () => {

              setIsNaturalPerson(true);
              onChange("type_person", 1);
            }}
            className="mr-2 appearance-none w-4 h-4 border border-[#5E5E63] bg-[#26262D] rounded-full 
            checked:border-[#5E5E63] checked:bg-[#26262D] checked:relative 
            checked:after:content-[''] checked:after:absolute checked:after:inset-0 
            checked:after:m-auto checked:after:w-[6px] checked:after:h-[6px] checked:after:bg-white 
            checked:after:rounded-full"          />
          {GLOBAL_LANGUAGE[language].benefactor.natural_person}

        </label>
        <label className="flex items-center text-[#B7B7B9]">
          <input
            type="radio"
            readOnly={true}


            name={`personType-${index}`}
            checked={!isNaturalPerson}
            onChange={data.id ? null : () => {
              setIsNaturalPerson(false);
              onChange("type_person", 2);
            }}
            value={!isNaturalPerson}
            className="mr-2 appearance-none w-4 h-4 border border-[#5E5E63] bg-[#26262D] rounded-full 
            checked:border-[#5E5E63] checked:bg-[#26262D] checked:relative 
            checked:after:content-[''] checked:after:absolute checked:after:inset-0 
            checked:after:m-auto checked:after:w-[6px] checked:after:h-[6px] checked:after:bg-white 
            checked:after:rounded-full"
          />
          {GLOBAL_LANGUAGE[language].benefactor.artificial_person}
        </label>
      </div>

      {/* Formulario de datos */}
      {isNaturalPerson ? (
        <div className="grid md:grid-cols-2 grid-cols-1 gap-4 mb-4">
          <div>
            <p className="text text-[#B7B7B9]">
              {GLOBAL_LANGUAGE[language].benefactor.natural_person_name}
            </p>
            <InputLogin
              readOnly={!!data.id}
              onChange={(e) => onChange("first_name", e)}
              value={data.first_name}
              error={error}
              placeholder={GLOBAL_LANGUAGE[language].benefactor.natural_person_name_placeholder}
            />
          </div>
          <div>
            <p className="text text-[#B7B7B9]">
              {GLOBAL_LANGUAGE[language].benefactor.natural_person_last_name}
            </p>
            <InputLogin
              readOnly={!!data.id}
              onChange={(e) => onChange("last_name", e)}
              value={data.last_name}
              error={error}
              placeholder={GLOBAL_LANGUAGE[language].benefactor.natural_person_last_name_placeholder}
            />
          </div>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 grid-cols-1 gap-4 mb-4">
          <div>
            <p className="text text-[#B7B7B9]">
              {GLOBAL_LANGUAGE[language].benefactor.artificial_person_name_company}
            </p>
            <InputLogin
              readOnly={!!data.id}
              onChange={(e) => onChange("enterprise_legal_name", e)}
              value={data.enterprise_legal_name}
              error={error}
              placeholder={GLOBAL_LANGUAGE[language].benefactor.artificial_person_name_company_placeholder}
            />
          </div>
          <div>
            <p className="text text-[#B7B7B9]">
              {GLOBAL_LANGUAGE[language].benefactor.artificial_person_identification_company}
            </p>
            <InputLogin
              readOnly={!!data.id}
              onChange={(e) => onChange("enterprise_identification", e)}
              value={data.enterprise_identification}
              error={error}
              placeholder={GLOBAL_LANGUAGE[language].benefactor.artificial_person_identification_company_placeholder}
            />
          </div>
        </div>
      )}

      {/* Campos adicionales */}
      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 mb-4">
        <div>
          <p className="text text-[#B7B7B9]">{GLOBAL_LANGUAGE[language].benefactor.porcentaje_benefactor}</p>
          <InputLogin
            readOnly={!!data.id}
            onChange={(e) => onChange("participation_percentage", e)}
            value={data.participation_percentage}
            error={error}
            placeholder={GLOBAL_LANGUAGE[language].benefactor.porcentaje_benefactor_paceholder}
          />
        </div>
        <div>
          <p className="text text-[#B7B7B9]">{GLOBAL_LANGUAGE[language].benefactor.country}</p>
          <SearchableSelect
            image
            readOnly={!!data.id}
            label={data.country}
            setSelectOpcion={(value) => onChange("country", value)}
            list={ListCountry}
            error={error}
          />
        </div>
      </div>

      {/* Documentos */}
      <div className="mt-6">
        <p className="text-sm my-1 text-[#B7B7B9]">
          {GLOBAL_LANGUAGE[language].steps4.doctitle1}
        </p>

        <UploadPDF
          readOnly={!!data.doc_government_issued_id ? false : true}
          setUploadedFile={(file) => handleDocumentChange("doc_government_issued_id", file)}
          uploadedFile={!!data.doc_government_issued_id ? document1 : data?.documents_step_4[0]?.url}
          error={false}
        />
      </div>
      <div className="mt-6">
        <p className="text-sm my-1 text-[#B7B7B9]">
          {GLOBAL_LANGUAGE[language].steps4.doctitle2}
        </p>
        <UploadPDF
          readOnly={!!data.doc_shareholder_certificate ? false : true}
          setUploadedFile={(file) => handleDocumentChange("doc_shareholder_certificate", file)}
          uploadedFile={!!data.doc_shareholder_certificate ? document2 : data?.documents_step_4[1]?.url}
          error={false}
        />
      </div>
    </div>
  );
};

export default BeneficiaryForm;
